/**
 * [退款列表]
 * @author: Fu Xiaochun
 * @date: 2021-09-27 
 */

import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import moment from 'moment';
import { XInput, XSelect, XDatePicker, XOKButton, XCancelButton, XTabNav } from '@/components/xqxc_ui';
import { SearchBox, SearchItem } from '@/components/Layout';
import { message, Modal } from 'antd';
import * as apis from '@/apis/finance/refund';
import { getEnum } from '@/apis/common/index';
import { regFenToYuan } from '@/util/money';
import TableList from './components/TableList';

const { confirm } = Modal;

function Refund(props){

    const defaultStartTime = moment().subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
    const defaultEndTime = moment().format('YYYY-MM-DD 23:59:59');
    const page = useRef({pageSize: 30, pageNum: 1});

    const $this = useRef({fetching: false});

    const [startTime, setStartTime] = useState(defaultStartTime);
    const [endTime, setEndTime] = useState(defaultEndTime);
    const [refundStatusEnum, setRefundStatusEnum] = useState([]);
    const [refundStatus, setRefundStatus] = useState({});
    const [refundTypeEnum, setRefundTypeEnum] = useState([]);
    const [refundType, setRefundType] = useState({});
    const [userName, setUserName] = useState();
    const [orderId, setOrderId] = useState();
    const [reset, setReset] = useState();

    const [listData, setListData] = useState({});
    const [summary, setSummary] = useState({});

    useEffect(()=>{
        props.setBreadcrumbPaths(props.match);
        onSearch();
        getRefundStatusEnums();
        getRefundTypeEnums();
    }, []);

    useEffect(()=>{
        reset && onSearch();
    }, [reset]);

    const onSearch = ()=>{
        let params = {
            startTime,
            endTime,
            refundStatus: refundStatus.code,
            refundType: refundType.code,
            userName,
            orderId,
            pageSize: page.current.pageSize,
            pageNum: page.current.pageNum
        };

        if(!startTime || !endTime){
            message.error('退款时间不能为空！');
            return false;
        }

        apis.getRefundList(params).then(res=>{
            setListData(res.result);
        }).catch(err=>{
            message.error(err.message);
        });

        apis.getRefundSummary(params).then(res=>{
            setSummary(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const onReset = ()=>{
        setStartTime(defaultStartTime);
        setEndTime(defaultEndTime);
        setRefundStatus({});
        setRefundType({});
        setUserName();
        setOrderId();
        setReset(Date.now());
        page.current = {pageNum: 1, pageSize: 30};
    };

    const onSearchHandle = ()=>{
        page.current = {pageNum: 1, pageSize: 30};
        onSearch();
    };

    const getRefundStatusEnums = ()=>{
        getEnum({enumName: 'PayRefundStatus'}).then(res=>{
            setRefundStatusEnum(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const getRefundTypeEnums = ()=>{
        getEnum({enumName: 'DeliveryRefundTypeEnum'}).then(res=>{
            setRefundTypeEnum(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const onStartDateChange = (data)=>{
        setStartTime(data);
        
    };

    const onEndDateChange = (data)=>{
        setEndTime(data);
        
    };

    const disabledStartDate = (current)=>{
        let diffEnd = current.diff(endTime, 'seconds', true);
        let diffToday = current.diff(moment().format('YYYY-MM-DD 23:59:59'), 'seconds', true);

        if(endTime){
            if(diffEnd < -(86400 * 31) || diffEnd >= 0){
                return true;
            }else{
                return false;
            }
        }else{
            if(diffToday > 0){
                return true;
            }else{
                return false;
            }
        }
    };

    const disabledEndDate = (current)=>{
        let diffStart = current.diff(startTime, 'seconds', true);
        let diffToday = current.diff(moment().format('YYYY-MM-DD 23:59:59'), 'seconds', true);
        let diffStart2Today = moment().diff(startTime, 'seconds', true);
        
        if(startTime){
            if(diffStart <= 0){
                return true;
            }else if( diffStart > (diffStart2Today + 86400) ){
                return true;
            }else if(diffStart > (86400 * 31)){
                return true;
            }else{
                return false;
            }
        }else{
            if(diffToday > (86400 * 0)){
                return true;
            }else{
                return false;
            }
        }
    };

    const onPageChange = (pageSize, pageNum)=>{
        page.current = {pageNum, pageSize};
        onSearch();
    };

    const tableAction = (type, item)=>{
        switch (type){
            case 'refund':
                // 退款
                confirm({
                    title: `确认对订单 ${item.orderId} 进行退款？`,
                    icon: null,
                    content: <div className={styles.confirmContent}><p><span>退款原因：</span>{item.refundReason}</p><p><span>退款金额：</span><strong>￥{regFenToYuan(item.refundAmount)}</strong></p></div>,
                    onOk() {
                        refundAction(item);
                    },
                });
                break;
            default: 
                // nothing to do
        }
    };

    const refundAction = (item)=>{
        if($this.current.fetching){
            return false;
        }
        $this.current.fetching = true;
        apis.toReFund({refundId: item.refundId}).then(res=>{
            let status = res.result ? res.result.status : '';
            switch (status){
                case 'SUCCESS':
                    message.success('退款成功！', 3);
                    break;
                case 'DOING':
                    message.success('退款中！', 3);
                    break;
                case 'FAILED':
                    message.error('退款失败！', 3);
                    break;
                default:
                    // nothing to do
            }
            onSearch();
        }).catch(err=>{
            message.error(err.message);
        }).finally(()=>{
            $this.current.fetching = false;
        });
    };

    return (
        <div className={styles.flexBoxContainer}>
            <SearchBox>
                <SearchItem>
                    <XDatePicker
                        label='退款时间'
                        value={startTime}
                        bindThis={setStartTime}
                        bindName='startTime'
                        isFormat
                        showTime={false}
                        defaultTime='00:00:00'
                        onChange={onStartDateChange}
                        disabledDate={disabledStartDate}
                    />
                    <div className={styles.timeLine} />
                    <XDatePicker
                        style={{ marginRight: 20 }}
                        label=''
                        value={endTime}
                        bindThis={setEndTime}
                        bindName='endTime'
                        isFormat
                        showTime={false}
                        defaultTime='23:59:59'
                        disabledDate={disabledEndDate}
                        onChange={onEndDateChange}
                    />
                </SearchItem>
                <SearchItem>
                    <XSelect
                        allowClear={true}
                        label='退款状态'
                        placeholder='请选择'
                        renderData={refundStatusEnum}
                        dataIndex='value'
                        keyIndex='code'
                        value={refundStatus.value}
                        showSearch={true}
                        bindThis={setRefundStatus}
                        bindName='refundStatus'
                    />
                </SearchItem>
                <SearchItem>
                    <XSelect
                        allowClear={true}
                        label='退款类型'
                        placeholder='请选择'
                        renderData={refundTypeEnum}
                        dataIndex='value'
                        keyIndex='code'
                        value={refundType.value}
                        showSearch={true}
                        bindThis={setRefundType}
                        bindName='refundType'
                    />
                </SearchItem>
                <SearchItem>
                    <XInput
                        allowClear={true}
                        label='下单账号'
                        placeholder='请输入'
                        value={userName}
                        bindThis={setUserName}
                        bindName='userName'
                    />
                </SearchItem>
                <SearchItem>
                    <XInput
                        allowClear={true}
                        label='订单号'
                        placeholder='请输入'
                        value={orderId}
                        bindThis={setOrderId}
                        bindName='orderId'
                    />
                </SearchItem>
                <SearchItem>
                    <XOKButton
                        label='查询'
                        onClick={onSearchHandle}
                    />
                    <XCancelButton
                        label='重置'
                        onClick={onReset}
                    />
                </SearchItem>
                <div style={{height: 0, clear: 'both'}}></div>
            </SearchBox>
            <div className={styles.summary}>
                <div className={styles.item}>订单实付金额: <span><i>￥</i>{regFenToYuan(summary.orderAmount)}</span></div>
                <div className={styles.item}>取消费用: <span><i>￥</i>{regFenToYuan(summary.cancelAmount)}</span></div>
                <div className={styles.item}>免取消费用: <span><i>￥</i>{regFenToYuan(summary.freeAmount)}</span></div>
                <div className={styles.item}>退款金额: <span><i>￥</i>{regFenToYuan(summary.refundAmount)}</span></div>
                <div className={styles.item}>退款失败数量: <span>{summary.refundFailCount}</span></div>
            </div>
            <TableList refundTypeEnum={refundTypeEnum} renderData={listData} tableAction={tableAction} paginationChange={onPageChange} />
        </div>
    );
}

Refund.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(Refund);